import { xIsMonotonic } from "../x/index.js";
import { xyCheck } from "./xyCheck.js";
/**
 * Filters x,y values to allow strictly growing values in x-axis.
 * @param data - object that contains property x (an ordered increasing array) and y (an array).
 * @returns filtered data with strictly increasing x values.
 */
export function xyEnsureGrowingX(data) {
    xyCheck(data);
    if (xIsMonotonic(data.x) === 1)
        return data;
    const x = Array.from(data.x);
    const y = Array.from(data.y);
    let prevX = Number.NEGATIVE_INFINITY;
    let currentIndex = 0;
    for (let index = 0; index < x.length; index++) {
        if (prevX < x[index]) {
            if (currentIndex < index) {
                x[currentIndex] = x[index];
                y[currentIndex] = y[index];
            }
            currentIndex++;
            prevX = x[index];
        }
    }
    x.length = currentIndex;
    y.length = currentIndex;
    return { x, y };
}
//# sourceMappingURL=xyEnsureGrowingX.js.map